import { useActor } from '@xstate/react';
import { TourDateMachineActor } from '../../machines/components/TourDateMachine';
import { TourDateView } from './TourDateView';

export function TourDateController({ actor }: { actor: TourDateMachineActor }) {
  const [state, send] = useActor(actor);

  return <TourDateView state={state} send={send} />;
}
